export default "__VITE_ASSET__39f81915__"